import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Live founding-member offer status. Polls so the "spots left" countdown
// updates on its own as members claim their spots.
export function useFoundingStatus(pollMs = 30000) {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let alive = true;
    const fetchIt = () =>
      axios.get(`${API}/founding/status`).then((r) => { if (alive) setStatus(r.data); }).catch(() => {});
    fetchIt();
    const id = pollMs ? setInterval(fetchIt, pollMs) : null;
    return () => { alive = false; if (id) clearInterval(id); };
  }, [pollMs]);
  return status;
}
